module.exports = __webpack_public_path__ + "img/Surveys.20686376.svg";